// assets
import { IconFriends, IconTrophy, IconSocial, IconUser, IconMessages } from "@tabler/icons";

// constant
const icons = {
    IconFriends,
    IconTrophy,
    IconSocial,
    IconUser,
    IconMessages,
};

// ==============================|| SOCIAL MENU ITEMS ||============================== //

const Social = {
    id: "Social",
    title: "Social",
    type: "group",
    children: [
        {
            id: "social hub",
            title: "Social Hub",
            type: "collapse",
            icon: icons.IconSocial,

            children: [
                {
                    id: "profile",
                    title: "Profile",
                    type: "item",
                    url: "/social/social-hub/profile/my-profile",
                    icon: icons.IconUser,
                    target: false,
                    children: [
                        {
                            id: "settings",
                            title: "Settings",
                            type: "item",
                            url: "/social/social-hub/profile/settings",
                            icon: icons.IconUser,
                            target: false,
                        },
                    ],
                },
                {
                    id: "friends",
                    title: "Friends",
                    type: "item",
                    url: "/social/social-hub/friends",
                    icon: icons.IconFriends,
                    target: false,
                },
                {
                    id: "discussion",
                    title: "Discussion",
                    type: "item",
                    url: "/social/social-hub/discussion",
                    icon: icons.IconMessages,
                    target: false,
                },
            ],
        },
        {
            id: "Leaderboard",
            title: "Leaderboard",
            type: "item",
            url: "/social/leaderboard",
            icon: icons.IconTrophy,
        },
    ],
};

export default Social;
